module.exports = __webpack_public_path__ + "media/images/promo/championship/Scoreboard_SVG-4e98aa6907ac647851d886b6a7d3b373.svg";